<navbar></navbar>
<div class="container bg-white">
    <div class="row">
        <div class="col">
            <h1>Itinerary</h1>
        </div>
    </div>
    <div class="row">
        <div class="col">
           <h4><b>FRIDAY</b></h4>
        </div>
    </div>
    <div class="row">
        <div class="col">17:00 - 22:00</div>
        <div class="col">Registration</div>
        <div class="col">Conference Room</div>
    </div>
    <div class="row">
        <div class="col">19:00</div>
        <div class="col">Casino Night</div>
        <div class="col">Student Union</div>
    </div>
    <div class="row">
        <div class="col">21:00</div>
        <div class="col">Opening Show</div>
        <div class="col">Student Union</div>
    </div>
    <div class="row">
        <div class="col">22:00</div>
        <div class="col">Council of Chiefs Meeting</div>
        <div class="col">Conference Room</div>
    </div>
    <div class="row">
        <div class="col">22:30</div>
        <div class="col">Vigil Rededication</div>
        <div class="col">Activity Field 4</div>
    </div>
    <div class="row">
        <div class="col">23:00</div>
        <div class="col">Lights Out</div>
        <div class="col"></div>
    </div>

    <div class="row">
        <div class="col">
            <br />
           <h4><b>SATURDAY</b></h4>
        </div>
    </div>
    <div class="row">
        <div class="col">07:00</div>
        <div class="col">Breakfast</div>
        <div class="col">Student Union</div>
    </div>
    <div class="row">
        <div class="col">07:30</div>
        <div class="col">Check-In</div>
        <div class="col">Student Union</div>
    </div>
    <div *ngFor="let training of trainings"class="row">
        <div [ngSwitch]="training.period" class="col">
            <span *ngSwitchCase="1">08:30</span>
            <span *ngSwitchCase="2">09:45</span>
            <span *ngSwitchCase="3">11:00</span>
        </div>
        <div class="col">{{ training.name }}</div>
        <div class="col">{{ training.location }}</div>        
    </div>
    <div class="row">
        <div class="col">12:30</div>
        <div class="col">Lunch</div>
        <div class="col">Student Union</div>
    </div>
    <div class="row">
        <div class="col">13:00</div>
        <div class="col">Competitions</div>
        <div class="col">Activity Fields</div>
    </div>
    <div class="row">
        <div class="col">16:30</div>
        <div class="col">Midway</div>
        <div class="col">Activity Field 7</div>
    </div>
    <div class="row">
        <div class="col">17:30</div>
        <div class="col">Youth Dinner</div>
        <div class="col">Student Union</div>
    </div>
    <div class="row">
        <div class="col">18:15</div>
        <div class="col">Adult Dinner</div>
        <div class="col">Student Union</div>
    </div>
    <div class="row">
        <div class="col">18:30</div>
        <div class="col">Section Elections</div>
        <div class="col">Amphitheater</div>
    </div>
    <div class="row">
        <div class="col">19:30</div>
        <div class="col">Saturday Show</div>
        <div class="col">Gymnasium</div>
    </div>
    <div class="row">
        <div class="col">21:00</div>
        <div class="col">Live Auction</div>
        <div class="col">Student Union</div>
    </div>
    <div class="row">
        <div class="col">21:00</div>
        <div class="col">Cracker Barrel</div>
        <div class="col">Student Union</div>
    </div>
    <div class="row">
        <div class="col">22:00</div>
        <div class="col">Brotherhood Ceremony</div>
        <div class="col">Activity Field 4</div>
    </div>
    <div class="row">
        <div class="col">23:00</div>
        <div class="col">Lights Out</div>
        <div class="col"></div>
    </div>

    <div class="row">
        <div class="col">
            <br />
           <h4><b>SUNDAY</b></h4>
        </div>
    </div>
    <div class="row">
        <div class="col">07:15</div>
        <div class="col">Scouts Own</div>
        <div class="col">Student Union</div>
    </div>
    <div class="row">
        <div class="col">08:00</div>
        <div class="col">Closing Banquet</div>
        <div class="col">Student Union</div>
    </div>
    <div class="row">
        <div class="col">09:00</div>
        <div class="col">Council of Chiefs Meeting</div>
        <div class="col">Conference Room</div>
    </div>
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
</div>


